export const CONFIG_FILE_NAME = ".scmsrc";
